import type { OptionsItemType } from '@home/components/NewRegionSelect/type';
import CommonCN from '@intelligence/_locales/zh-CN/common';
import CommonEN from '@intelligence/_locales/en-US/common';
import {
  ROBLOX_GAME_RANK_CATEGORIES,
  getRobloxRankCategoryBySource,
} from '../config/robloxRankSourceConfig';

export const ROBLOX_RANK_CASCADER_JOINER = '###';

const getRankLabelByLocale = (labelKey: string, locale: 'cn' | 'en'): string => {
  const messages = locale === 'cn' ? CommonCN : CommonEN;
  return messages[labelKey as keyof typeof messages] || labelKey;
};

export const buildRobloxRankCascaderValue = (
  category: string,
  source: string,
): string => `${category}${ROBLOX_RANK_CASCADER_JOINER}${source}`;

export const parseRobloxRankCascaderValue = (
  value: string,
): { category: string; source: string } => {
  const [category, ...rest] = value.split(ROBLOX_RANK_CASCADER_JOINER);
  return {
    category: category || '',
    source: rest.join(ROBLOX_RANK_CASCADER_JOINER),
  };
};

export const sourcesToCascaderValues = (sources: string[]): string[] => {
  return sources
    .map((source) => {
      const category = getRobloxRankCategoryBySource(source);
      if (!category) {
        return '';
      }

      return buildRobloxRankCascaderValue(category, source);
    })
    .filter(Boolean);
};

export const cascaderValuesToSources = (values: string[]): string[] => {
  return values
    .map((value) => parseRobloxRankCascaderValue(value).source)
    .filter(Boolean);
};

export const buildRobloxRankCascaderOptions = (): OptionsItemType[] => {
  return ROBLOX_GAME_RANK_CATEGORIES.map((category) => ({
    value: category.value,
    text: getRankLabelByLocale(category.labelKey, 'en'),
    textCN: getRankLabelByLocale(category.labelKey, 'cn'),
    children: category.sources.map((source) => ({
      value: buildRobloxRankCascaderValue(category.value, source.value),
      text: getRankLabelByLocale(source.labelKey, 'en'),
      textCN: getRankLabelByLocale(source.labelKey, 'cn'),
    })),
  }));
};
